import CAxios from '../../../http/requests/cross-checking/report/index';
import FAAxios from '../../../http/requests/factory-tests';

export default {
    setChecklistItemValue ({ commit }, payload) {
        commit('SET_CHECKLIST_ITEM_VALUE', payload);
    },
    openModal ({ commit }, payload) {
        commit('OPEN_MODAL', payload.open);
        commit('SET_REVISION', payload.revision);
        commit('SET_MODAL_ERRORS', {});
    },
    setData ({ commit }, data) {
        commit('SET_MODAL_DATA', data);
    },
    addFile ({ commit }, data) {
        commit('ADD_FILE', data);
    },
    removeFile ({ commit }, index) {
        commit('REMOVE_FILE', index);
    },
    getUploadUrl: function ({ commit }, payload) {
        return new Promise((resolve, reject) => {
            CAxios.getFileUploadUrl(payload.projectId, payload.fileName).then(response => {
                if (!response.data.success) {
                    reject({ message: response.data.message });
                }

                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    toggleConfirmationModal ({ commit }, data) {
        commit('TOGGLE_CONFIRMATION_MODAL', data);
    },
    toggleIsUploading ({ commit }, isUploading) {
        commit('TOGGLE_IS_UPLOADING', isUploading);
    },
    createUpdateReport ({ commit }, payload) {
        return new Promise((resolve, reject) => {
            CAxios.createUpdateReport(payload.report, payload.revisionId, payload.completed)
                .then(response => {
                    commit('SET_MODAL_ERRORS', {});
                    response.data.data.checklist.map(classification => {
                        classification.items.map(item => {
                            item.name = item.item;
                            return item;
                        });
                        return classification;
                    });
                    commit('SET_MODAL_DATA', response.data.data);

                    resolve(response);
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        commit('SET_MODAL_ERRORS', error.response.data.data);
                    }

                    reject(error);
                });
        });
    },
    getCreationData ({ commit }) {
        return new Promise((resolve, reject) => {
            CAxios.getCreationData()
                .then(response => {
                    commit('SET_CREATION_DATA', response.data.data);
                    resolve(response);
                }).catch(error => {
                reject(error);
            });
        });
    },
    getReport ({ commit }, payload) {
        return new Promise((resolve, reject) => {
            CAxios.getReport(payload.revisionId)
                .then(response => {
                    if (response.data.data.report !== null) {
                        response.data.data.report.checklist.map(classification => {
                            classification.items.map(item => {
                                item.name = item.item;
                                return item;
                            });
                            return classification;
                        });
                        commit('SET_MODAL_DATA', response.data.data.report);
                    }
                    resolve(response);
                }).catch(error => {
                reject(error);
            });
        });
    },
};
